import { render, staticRenderFns } from "./CollapsibleK12MenuLayout.vue?vue&type=template&id=328e293f&scoped=true"
import script from "./CollapsibleK12MenuLayout.vue?vue&type=script&lang=ts"
export * from "./CollapsibleK12MenuLayout.vue?vue&type=script&lang=ts"
import style0 from "./CollapsibleK12MenuLayout.vue?vue&type=style&index=0&id=328e293f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e293f",
  null
  
)

export default component.exports